<template>
  <IQOS :title="$t('settings_cafe.currency.title')" :readonly="editing">
    <p class="comment pt-0 c-grey">
      {{ $t("settings_cafe.currency.desc") }}
    </p>
    <BlackSelect
      class="currency-select"
      v-model="currency_id"
      :readonly="!editing"
      v-if="available_currencies.length"
    >
      <option
        :value="item._id"
        v-for="item in available_currencies"
        :key="item._id"
      >
        {{ item.name }} ({{ item.symbol }})
      </option>
    </BlackSelect>

    <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="onEditFinish"
    />
  </IQOS>
</template>

<script>
import BlackSelect from "@/components/BlackSelect.vue";
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import CurrencyAPI from "@/api/currency";

export default {
  components: {
    BlackSelect,
    IQOS,
    IQOSActions,
  },
  data() {
    return {
      currency_id: null,
      available_currencies: [],

      editing: false,
    };
  },
  methods: {
    fetchCurrencies() {
      CurrencyAPI.getAll()
        .then((data) => {
          this.available_currencies = data.currencies;
          this.reset();
        })
        .catch((error) => {
          this.$store.dispatch("showError", "currency_error");
        });
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.editing = false;

      this.$store.commit("setCafeCurrencyId", this.currency_id);
      this.$store.dispatch("saveCafe");
      this.$store.dispatch("fetchCurrency");
    },
    reset() {
      if (this.cafe.currency_id) {
        this.currency_id = this.cafe.currency_id;
      } else {
        this.currency_id = this.available_currencies[0]._id;
      }
    },
  },
  mounted() {
    this.fetchCurrencies();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style scoped>
.currency-select {
  margin-top: 1vh;
  width: 100%;
}
</style>
